import React, { useContext } from 'react';

import { CardSettingsModal } from '../../card-settings-modal/CardSettingsModal';
import { CreateGroupModal } from '../../create-group-modal/CreateGroupModal';
import { CreateQueueModal } from '../../create-queue-modal/CreateQueueModal';
import { GroupCard } from '../../group-card/GroupCard';
import { QueueContext } from '../../queue-context/QueueContext';

function MonitoringTab() {
  const {
    groups,
    isGroupModalOpen,
    closeGroupModal,
    editingGroupName,
    isStreamModalOpen,
    closeStreamModal,
    isSettingsModalOpen,
    setIsSettingsModalOpen,
  } = useContext(QueueContext);

  return (
    <>
      <CardSettingsModal
        isOpen={isSettingsModalOpen}
        onClose={() => setIsSettingsModalOpen(false)}
      />
      <CreateQueueModal
        groupName={editingGroupName}
        isOpen={isStreamModalOpen}
        onClose={closeStreamModal}
      />
      <CreateGroupModal
        groupName={editingGroupName}
        isOpen={isGroupModalOpen}
        onClose={closeGroupModal}
      />
      {
        groups.map((group) => {
          return (
            <GroupCard groupName={group} key={group} />
          );
        })
      }
    </>

  );
}

export { MonitoringTab };
